export type SearchCadence = "DAILY" | "WEEKLY" | "MONTHLY";

export const getScheduleLabel = (cadence: SearchCadence | null | undefined) => {
  if (!cadence) return "Schedule";

  switch (cadence) {
    case "DAILY":
      return "Daily";
    case "WEEKLY":
      return "Weekly";
    case "MONTHLY":
      return "Monthly";
  }
};
